import {
  getChartLabel,
  getDeleteLabel,
  getImageFileName,
  getListLabel,
  getVisibilityLabel,
  inputLabel,
  isSvg,
  lockLabel,
  unlockLabel,
} from '@carboncopyco/editor-ui';
import { type IDynamicEditData, IDynamicEditType } from '@carboncopyco/types';

export const getEditLabel = (edit: IDynamicEditData) => {
  const editTypeToLabelFunction: () => string = {
    [IDynamicEditType.text]: () =>
      `${edit.element.old.value} ${edit.element.new.value}`,
    [IDynamicEditType.chart]: () => getChartLabel(edit.element),
    [IDynamicEditType.image]: () =>
      `Image ${isSvg(edit.element.old.value) ? 'SVG' : ''} ${getImageFileName(
        edit.element.old.value
      )}`,
    [IDynamicEditType.list]: () => getListLabel(edit.element),
    [IDynamicEditType.input]: () => inputLabel,
    [IDynamicEditType.visibility]: () => getVisibilityLabel(edit.element),
    [IDynamicEditType.delete]: () => getDeleteLabel(edit.element),
    [IDynamicEditType.lock]: () => lockLabel,
    [IDynamicEditType.unlock]: () => unlockLabel,
    [IDynamicEditType.style]: () =>
      edit.element.new.value || 'Unknown css property',
  }[edit.type];

  return editTypeToLabelFunction?.() ?? edit.element.new.value;
};

export const getFilteredEdits = (
  editsByFilters: Record<string, IDynamicEditData[]>,
  typesFilter: Record<string, string>
) => {
  const isAnyFilterSelected = Object.values(typesFilter).some(Boolean);

  const editsByFiltersAndType = isAnyFilterSelected
    ? Object.entries(editsByFilters).reduce(
        (acc, [url, edits]) => {
          acc[url] = edits.filter((edit) => typesFilter[edit.type]);
          return acc;
        },
        {} as Record<string, IDynamicEditData[]>
      )
    : editsByFilters;

  const editsWithValuesOnly = Object.entries(editsByFiltersAndType).filter(
    ([_, edits]) => edits.length
  );
  return Object.fromEntries(editsWithValuesOnly);
};
